// extracted by mini-css-extract-plugin
export var downArrow = "_g0-0";
export var infoTooltipIcon = "_g0-3";
export var label = "_g0-1";
export var optionCard = "_g0-4";
export var upArrow = "_g0-2";